













import { FilterConfig as InstanceFilterConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/filters-config';
import { RegularFilterConfig as InstanceRegularFilterConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-config';

import Vue from 'vue';

import { FilterTypeEnum } from '../../../enums';

import { UiSelect } from '../../keen-ui';

export default {
  name: 'tool-config-form',
  props: {
    toolConfig: {
      type: Object,
      required: true
    },
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    UiSelect
  },
  computed: {
    pivotsSelectOptions: function (): any[] {
      return Object.values(this.instance.filters)
        .reduce((pivotsOptions: any, filterConfig: InstanceFilterConfig) => {
          if (filterConfig.type === FilterTypeEnum.REGULAR) {
            const regularFilterConfig = filterConfig as InstanceRegularFilterConfig;
            pivotsOptions.push({
              value: (regularFilterConfig.toolingId || regularFilterConfig.id),
              label: (regularFilterConfig.prettyName || this.$epb.messages.filters.names[regularFilterConfig.id] ||
                regularFilterConfig.id)
            });
          }
          return pivotsOptions;
        }, []) as any[];
    },
    pivotsSelectedValues: function (): any[] {
      if (!this.toolConfig.pivotIds) {
        return [];
      } else {
        return this.pivotsSelectOptions.filter((option: any) => this.toolConfig.pivotIds.includes(option.value));
      }
    }
  },
  data: function () {
    return {
      messages: this.$epb.messages.tools.instances.fields.tools.base.fields
    };
  },
  methods: {
    onPivotsSelectedValuesChange: function (selectedOptions: any[]): void {
      const selectedPivotIds: string[] = selectedOptions.map(option => option.value);
      if (!!selectedPivotIds.length) {
        if (!this.toolConfig.pivotIds) {
          Vue.set(this.toolConfig, 'pivotIds', selectedPivotIds);
        } else {
          this.toolConfig.pivotIds = selectedPivotIds;
        }
      } else {
        Vue.delete(this.toolConfig, 'pivotIds');
      }
    }
  }
};
